import { Divider } from 'antd';
import Footer from './Footer';
import PluginsSection from './PluginsSection';
import MarqueeSection from './MarqueeSection';
import HeroSection from './HeroSection';
import RecommendedSection from './RecommendedSection';
import CapabilitySection from './CapabilitySection';
import TrustSection from './TrustSection';

import './index.less';
import { useEffect } from 'react';
import { getLoginModalStore } from '~/components/LoginModal/store';
import { useSEO } from '~/hooks/useSEO';
import { HOME_SEO } from '~/seo/site';

const HomePage = () => {
  useSEO(HOME_SEO);

  useEffect(() => {
    getLoginModalStore().open = false;
  }, []);
  return (
    <div className="home-page">
      <HeroSection />
      <RecommendedSection />
      <CapabilitySection />
      <PluginsSection />
      <TrustSection />
      <MarqueeSection />
      <Divider className="m-0" />
      <Footer />
    </div>
  );
};

export default HomePage;
